//#region src/omnivore_pos_type.ts
var OmnivorePosType = /* @__PURE__ */ function(OmnivorePosType) {
	OmnivorePosType["Test"] = "mock";
	OmnivorePosType["Micros3700"] = "micros3700";
	OmnivorePosType["Simphony1"] = "simphony1";
	OmnivorePosType["Simphony18_2"] = "simphony_18_2";
	OmnivorePosType["Simphony2"] = "simphony";
	OmnivorePosType["NcrAloha"] = "ncrAloha";
	OmnivorePosType["ParBrink"] = "brink";
	OmnivorePosType["Positouch"] = "positouch";
	return OmnivorePosType;
}(OmnivorePosType || {});
//#endregion
export { OmnivorePosType };

//# sourceMappingURL=omnivore_pos_type.js.map